import React, { useState } from 'react'
import { Card, Row, Col, Collapse } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import BusinessElementCard from '../BusinessElementCard';
import { TeachBubble } from '../../../../Templates/TeachBubble';
import { BoardElementConfigHelpTexts, BoardCreacionHelpTexts } from '../../../../../common/HelpPageText';
import PropTypes from 'prop-types';
import { useBoolean } from '@fluentui/react-hooks';

import DialogGenerateGap from '../../DialogGenerateGap'
import '../../../../../styles/css/RelatedConcept.css'
import { CalloutFocusTrapExample } from './FieldFilter';
import NoDataLayer from '../../../../Common/NoDataLayer';
import { useGetGapDataseriePossiblesGaps } from '../../../../../hooks/services/sKPI/useOfGAP';
import { __enum_PageMode, enum__BUTTONKEYS_KPI, enum__PRIVILEGES } from '../../../../../common/Dictionaries';
import { useHistory } from 'react-router-dom';
import ToolBar from '../../../../Common/Toolbar';
import MainAppContext from '../../../../../MainAppContext';
import BoardAppContext from '../../../../../BoardAppContext';
import { useContext } from 'react'; 
import { ActionButton } from '@fluentui/react';
import { setLocalStorageValue } from '../../../../../common/Helpers';
import { __onGoToCreateBoard } from '../../../../../common/SystemRedirections';
import SidePanelAddConsolidation from './SidePanelAddConsolidation';
import { useDispatch, useSelector } from 'react-redux';
import { action_setBoardMoveZones, action_updateBoardFullStructureNewContainers, action_updateBoardFullStructureNewTemporal } from '../../../../../reducers/actions/KPI/actions';
import { _checkSecurityUser } from '../../../../../common/Helpers/HLP_Security';
import { setBoardContainerHtml } from '../../../../../services/sKPI/board.service';


function BoardElementTypeBox(props) {
    //Helpers
    const { t } = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { token: currentAuth } = useSelector((state) => state.auth);

    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);
    const { _boardStructure: objBoard } = useSelector((state) => state.boardScope);
    const { _boardStructureNew: objNewStructure } = useSelector((state) => state.boardScope);
    const { _boardScopeValues: objBoardScopeValues } = useSelector((state) => state.boardConsGroupScope);
    const { _moveZones: boardMoveZones } = useSelector((state) => state.boardScope);
    
    //Parametros de entrada.
    const { 
        inputParam_EditMode = false,
        inputParam_SetElements = null,
        inputParam_ShowFilters = false,
        inputParam_CheckBoardId = false,
        inputParam_CardElementNameIsDataLang = false,
        inputParam_BoardId = null,
        inputParam_ElementList = null,
        inputParam_ShowSelected = false,
        inputParam_SetterBoardElements = null,
        inputParam_SetterStatusFly = null,       
        inputParam_EnableCollapse = false,
        inputParam_SetterSelectedElement = null,
        inputParam_GroupDataseriesInOneList = false,
        inputParam_SetGroupDataseriesInOneList = null,
    } = props;
    

    //Parametros de componente.
    const inputParam_HasBoardStructure = objBoard.l_structure.length > 0;
    const [showContent, setShowContent] = useState(false);
    const [selectedElementCard, setSelectedElementCard] = useState(null);
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [isAddConsolidationPanelOpen, setIsAddConsolidationPanelOpen] = useState(false);

    const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);

    const [dataserieList, setDataserieList] = useState(null);
    const [gapAnalyzeList, setGapAnalyzeList] = useState(null);
    const [revisionList, setRevisionList] = useState(null);
    const [processPosibleGapsConfig, setProcessPosibleGapsConfig] = useState(null);
    useGetGapDataseriePossiblesGaps(selectedElementCard, null, inputParam_BoardId, dataserieList, setDataserieList, setGapAnalyzeList, setProcessPosibleGapsConfig, isDialogVisible)

    const _priv_canMoveZones = _checkSecurityUser(contextSite.onlyObserver, contextBoard.userPropsKpi.value, contextSite.securityProps, null, enum__PRIVILEGES.KPI_CONTRACT_CREATE);
    const _priv_canProcessGAP = _checkSecurityUser(contextSite.onlyObserver, contextBoard.userPropsKpi.value, contextSite.securityProps, null, enum__PRIVILEGES.GAP_CONTRACT_ANALYZE);
    const _priv_canCreateBoard = _checkSecurityUser(contextSite.onlyObserver, contextBoard.userPropsKpi.value, contextSite.securityProps, null, enum__PRIVILEGES.KPI_CONTRACT_CREATE);
    const _priv_canAddConsolidationGroup = _checkSecurityUser(contextSite.onlyObserver, contextBoard.userPropsKpi.value, contextSite.securityProps, selectedElementCard !== null ? selectedElementCard.elementId : 0, enum__PRIVILEGES.KPI_CONTRACT_CREATE)

    //Funciones de componente.
    const selectCard = (card) => {
        if (selectedElementCard !== null) {
            if (card.id === selectedElementCard.id) {
                card = null
            }
        }

        inputParam_SetElements && inputParam_SetElements(null)

        inputParam_SetterSelectedElement && inputParam_SetterSelectedElement({
            elementType: card,
            fireUpdate: true
        })
        
        setSelectedElementCard(card)

        contextBoard.selectedElement.set && contextBoard.selectedElement.set({
            elementType: card,
            fireUpdate: true
        })
    };

    //Eventos de componente.

    const onOpenProcessGap = (e) => {
        showDialog()
    };

    const onGroupDataseries = (e) => {
        inputParam_SetGroupDataseriesInOneList(!inputParam_GroupDataseriesInOneList)
        setLocalStorageValue('PARAM_COOKIE_DATASERIES_GROUPED' + inputParam_BoardId, !inputParam_GroupDataseriesInOneList)
    };

    const onChangeMoveZones = (moveZones, fireSave) => {
        let newStructure = objNewStructure;

        if (!moveZones && fireSave) {
            setBoardContainerHtml(objBoard.id, newStructure).then((response) => {
                if (response.data.data === "succedded") {
                    //Mensaje de exito.
                    //Actualizacion de structure redux.
                    dispatch(action_updateBoardFullStructureNewContainers(objNewStructure))
                }
                else {
                    //Mensaje de error.
                }
            }).catch(() => {
                //Mensaje de error.
            });
        }
        else if (!moveZones && !fireSave) {
            //Mensaje de exito.
            //Actualizacion de structure redux.
            dispatch(action_updateBoardFullStructureNewTemporal(objBoard.l_structure[0].l_container, false))
        }

        dispatch(action_setBoardMoveZones(moveZones))
    };

    //Toolbar (Debe estar previo al render para no generar problemas de que no existan los eventos previo a ser instanciados)
    const overflowItems = [
        {
            key: enum__BUTTONKEYS_KPI.MOVE_BOARD_ZONES,
            text: boardMoveZones ? t('data-lang-btn-stopmovezones-save') : t('data-lang-btn-movezones'),
            iconProps: { iconName: boardMoveZones ? 'Save' : 'Move' },
            onClick: () => onChangeMoveZones(!boardMoveZones, true),
            hidden: !(inputParam_HasBoardStructure && _priv_canMoveZones.value && _priv_canMoveZones.mode === __enum_PageMode.Edit)
        },{
            key: enum__BUTTONKEYS_KPI.MOVE_BOARD_ZONES,
            text: t('data-lang-btn-stopmovezones-cancel'),
            iconProps: { iconName: 'Undo' },
            onClick: () => onChangeMoveZones(false, false),
            hidden: !(inputParam_HasBoardStructure && _priv_canMoveZones.value && _priv_canMoveZones.mode === __enum_PageMode.Edit)
        },{
            key: enum__BUTTONKEYS_KPI.ADD_BOARD_CONSOLIDATION_GROUP,
            text: t('data-lang-btn-addconsolidation') ,
            iconProps: { iconName: 'Add' },
            onClick: () => setIsAddConsolidationPanelOpen(!isAddConsolidationPanelOpen),
            hidden: !(_priv_canAddConsolidationGroup.value && _priv_canAddConsolidationGroup.mode === __enum_PageMode.Edit)
        },{
            key: 'groupdataseries',
            text: inputParam_GroupDataseriesInOneList ? t('data-lang-btn-ungroupdataseries') : t('data-lang-btn-groupdataseries'),
            iconProps: { iconName: 'RowsGroup' },
            onClick: onGroupDataseries,
        },{
            key: enum__BUTTONKEYS_KPI.PROCESS_GAP,
            disabled: selectedElementCard === null,
            title: selectedElementCard === null ? t('data-lang-lbl-disabled'): null,
            text: t('data-lang-btn-processgap'),
            iconProps: { iconName: 'ServerProcesses' },
            onClick: onOpenProcessGap,
            hidden: !(inputParam_HasBoardStructure ? (_priv_canProcessGAP.value && _priv_canProcessGAP.mode === __enum_PageMode.Edit) : false)
        },{
            key: enum__BUTTONKEYS_KPI.CREATE_BOARD,
            text: t('data-lang-btn-configuration'),
            iconProps: { iconName: 'ServerProcesses' },
            subMenuProps: {
                items: [
                    {
                        key: enum__BUTTONKEYS_KPI.CREATE_BOARD,
                        text: !inputParam_HasBoardStructure ? t('data-lang-btn-boardconfiguration') : t('data-lang-btn-viewboardconfiguration'),
                        iconProps: { iconName: !inputParam_HasBoardStructure ? 'ServerProcesses' : 'View' },
                        onClick: () => __onGoToCreateBoard(inputParam_BoardId, history),
                        hidden: !(_priv_canCreateBoard.value && _priv_canCreateBoard.mode === __enum_PageMode.Edit)
                    },{
                        key: 'panelConfiguration',
                        text: t('data-lang-lbl-configuration'),
                        iconProps: { iconName: 'Settings' },
                        onClick: toggleIsCalloutVisible,
                    },
                ],
            }
        }
    ]
    .filter(x => (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) && !inputParam_HasBoardStructure ? true : (inputParam_HasBoardStructure ? true : (x.key !== enum__BUTTONKEYS_KPI.CREATE_BOARD)))
    
    const onCollapseExpandContent = () => {
        setShowContent(!showContent)
    };

    const onRenderContent = () => {
        return  <div className='h-100'>
                    <Card.Footer className='w-100' style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                    </Card.Footer>
                    <Card.Body className="board-element-form-body pt-2 w-100 h-100">
                        <Row>
                            {
                                (inputParam_CheckBoardId ? !isNaN(inputParam_BoardId) : true) && (inputParam_ElementList ? inputParam_ElementList : contextBoard.boardElementList.value).map((element, index) => 
                                    <Col key={ index } className={`mb-2 px-1`} style={{minWidth: "400px", maxWidth: "700px"}}>
                                        <BusinessElementCard
                                            inputParam_ElementItem={ element }
                                            inputParam_EditMode={ inputParam_EditMode }
                                            inputParam_ShowSelected={inputParam_ShowSelected}
                                            inputParam_SetterSelectedElement={ selectCard }
                                            inputParam_TextIsDataLang={ inputParam_CardElementNameIsDataLang }
                                            inputParam_SelectedCardId={ selectedElementCard !== null ? selectedElementCard.id : 0 }
                                            inputParam_BoardId={inputParam_BoardId}
                                            inputParam_SetterBoardElements={inputParam_SetterBoardElements}
                                            inputParam_SetterStatusFly={inputParam_SetterStatusFly}
                                        />
                                    </Col>
                                )
                            }
                            {
                                (inputParam_CheckBoardId ? isNaN(inputParam_BoardId) : false) && <NoDataLayer display={isNaN(inputParam_BoardId)} />
                            }
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        {
                            selectedElementCard && dataserieList && revisionList && processPosibleGapsConfig &&
                            <DialogGenerateGap
                                inputParam_EditMode={false}
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_Element={selectedElementCard}
                                inputParam_IsDialogOpen={isDialogVisible}
                                inputParam_SetterIsDialogOpen={hideDialog}
                                inputParam_DataserieList={dataserieList}
                                inputParam_SetDataserieList={setDataserieList}
                                inputParam_RevisionList={revisionList}
                                inputParam_SetRevisionList={setRevisionList}
                                inputParam_GapAnalyzeList={gapAnalyzeList}
                                
                                inputParam_ProcessPosibleGapsConfig={processPosibleGapsConfig}
                                inputParam_SetProcessPosibleGapsConfig={setProcessPosibleGapsConfig}
                            />
                        }
                        {
                            objBoardScopeValues &&
                            <SidePanelAddConsolidation
                                inputParam_BoardId={inputParam_BoardId}
                                inputParam_IsPanelOpen={isAddConsolidationPanelOpen}
                                inputParam_SetterIsPanelOpen={setIsAddConsolidationPanelOpen}
                            />
                        }
                        
                    </Card.Footer>
                </div>
    }
    //Render de componente.
    return (
        <Card className='board-element-form h-100'>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{ !inputParam_ShowFilters ? t('data-lang-boxname-boardelementtypes') : t('data-lang-boxname-boardelements')}</b>
                    <div className='toolbar d-flex' id={"filter-board-field-callout-button"}>
                        <ToolBar overflowItems={ overflowItems } styles={{root: {height: "30px"}}} display={ inputParam_ShowFilters } />
                        {
                            inputParam_HasBoardStructure && inputParam_ShowFilters &&
                            <CalloutFocusTrapExample showButton={false} isCalloutVisible={isCalloutVisible} toggleIsCalloutVisible={toggleIsCalloutVisible} />
                        }
                        {
                            inputParam_EditMode &&
                            <TeachBubble
                                inputParam_ButtonId={ "btnHelpSelectElementType" }
                                inputParam_Text={ t(inputParam_ShowSelected ? BoardCreacionHelpTexts.selectElementType : BoardElementConfigHelpTexts.selectElementType)}
                                inputParam_Title={ t('data-lang-helptext-title') }
                            />
                        }
                        {
                            inputParam_EnableCollapse &&
                            <ActionButton onClick={onCollapseExpandContent} iconProps={ { iconName: showContent ? 'Blocked2' : 'CirclePlus' } } styles={{root:{height: "30px"}}} display={ true }>
                                { showContent ? t('data-lang-lbl-collapse') :  t('data-lang-lbl-expand') }
                            </ActionButton>
                        }
                    </div>
                </Card.Title>
            </Card.Header>
            {
                inputParam_EnableCollapse && 
                <Collapse in={showContent} direction="up">
                    {
                        onRenderContent()
                    }
                </Collapse>
            }
            {
                !inputParam_EnableCollapse && 
                <>
                    {
                        onRenderContent()
                    }
                </>
            }
        </Card>
    );
}

///Proptypes
BoardElementTypeBox.propTypes = {
    inputParam_BoardId: PropTypes.number,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_ShowSelected: PropTypes.bool.isRequired,
    inputParam_ShowFilters: PropTypes.bool.isRequired,
    inputParam_CheckBoardId: PropTypes.bool.isRequired,
    inputParam_CardElementNameIsDataLang: PropTypes.bool.isRequired,
    
    inputParam_SetterFieldBoardSelection: PropTypes.func,
    inputParam_SetterNoAggregation: PropTypes.func,
    inputParam_SetterBoardElements: PropTypes.func,
    inputParam_SetterStatusFly: PropTypes.func,
    inputParam_SetElements: PropTypes.func,
    
    inputParam_BoardElements: PropTypes.array,

    inputParam_GroupDataseriesInOneList: PropTypes.bool,
    inputParam_SetGroupDataseriesInOneList: PropTypes.func,

};

export default BoardElementTypeBox;